import { Trans } from '@lingui/macro'
import { authRoles } from 'app/auth/authRoles'
import { RouteConfig } from 'app/router/Routes'
import { EgretLoadable } from 'egret'
import Reports from '../grants/grantee-reports/Reports'
import { FUNDING_PATHS } from './FundingConstants'

const Apply = EgretLoadable({
  loader: async () => await import('./ApplyForFunding')
})

const ApplicationsList = EgretLoadable({
  loader: async () => await import('../grants/applications/ApplicationsList')
})

const HowToApply = EgretLoadable({
  loader: async () => await import('./HowToApply')
})

const fundingRoutes: RouteConfig[] = [
  {
    path: FUNDING_PATHS.APPLY,
    component: Apply,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_APPLY_FOR_FUNDING</Trans>,
    errorRedirectPath: FUNDING_PATHS.APPLY
  },
  {
    path: FUNDING_PATHS.APPLICATIONS_LIST,
    component: ApplicationsList,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_APPLICATIONS</Trans>,
    showCollapseBtn: true
  },
  {
    path: FUNDING_PATHS.HOW_TO_APPLY,
    component: HowToApply,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_HOW_TO_APPLY</Trans>
  },
  {
    path: FUNDING_PATHS.GRANT_APPLICATION + '/:id/:viewType?',
    component: EgretLoadable({
      loader: async () => await import('../grants/applications/Application')
    }),
    auth: authRoles.grantee,
    label: <Trans>GRANTS_ROUTES_GRANT_APPLICATION_ROUTE_LABEL</Trans>,
    isConditionable: true,
    id: 'grant-application',
    showCollapseBtn: true,
    collapseByDefault: true,
    errorRedirectPath: FUNDING_PATHS.APPLICATIONS_LIST
  },
  {
    path: FUNDING_PATHS.PREQUALIFICATION + '/:id/:viewType?',
    component: EgretLoadable({
      loader: async () => await import('../grants/applications/Prequalification')
    }),
    auth: authRoles.grantee,
    label: <Trans>GRANTS_ROUTES_GRANTS_PREQUALIFICATION_ROUTE_LABEL</Trans>,
    isConditionable: true,
    id: 'prequalification',
    errorRedirectPath: FUNDING_PATHS.APPLICATIONS_LIST
  },
  {
    path: FUNDING_PATHS.REPORTS,
    component: Reports,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_GRANTEE_REPORTS</Trans>,
    showCollapseBtn: true
  },
  {
    path: FUNDING_PATHS.REPORT + '/:id/',
    component: EgretLoadable({
      loader: async () => await import('../grants/grantee-reports/GranteeReport')
    }),
    auth: authRoles.grantee,
    showCollapseBtn: true,
    collapseByDefault: true,
    errorRedirectPath: FUNDING_PATHS.REPORTS
  },
  {
    path: FUNDING_PATHS.REPORT_PREVIEW + '/:id/',
    component: EgretLoadable({
      loader: async () => await import('../grants/grantee-reports/GranteeReport')
    }),
    auth: authRoles.grantee,
    showCollapseBtn: true,
    collapseByDefault: true,
    errorRedirectPath: FUNDING_PATHS.REPORTS
  }
]

export default fundingRoutes
